import styled, { css } from "styled-components"
import { desktopTextStyles } from "./typography.styles"
import Breakpoints from "./breakpoints"

export const OverlayContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  z-index: 200;

  transition: 0.4s ease-out all;
  height: 65px;

  ::before {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    /* var(--tricorn-black) * 0.85 opacity */
    background-color: rgba(40, 40, 40, 0.85);
    mix-blend-mode: multiply;
  }

  & p {
    ${desktopTextStyles.HeadingFiveRegular}
    color: var(--white);
    padding: 22px 0;
    margin: 0 22px;
    max-width: 80%;

    text-align: center;
    mix-blend-mode: normal;
  }
`

export const VenueLabel = styled.span``
export const ActionLabel = styled.span``

export const ImageTileContainer = styled.div`
  background-size: cover;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;

  & ${ActionLabel} {
    display: none;
  }

  height: 33vw;

  ${props =>
    props.isActive &&
    css`
      & > ${OverlayContainer} {
        height: 100%;
        ::before {
          background-color: rgba(191, 67, 32, 0.85);
          mix-blend-mode: normal;
        }
      }

      & p {
        padding: 16px 32px;
      }

      & ${VenueLabel} {
        display: none;
      }
      & ${ActionLabel} {
        display: inline;
      }
    `}
`

export const SliderContainer = styled.div`
  .slick-dots {
    transform: translateY(8px);
  }
`
